module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("wo weeks later, Adam drove the hour commute from his town house to Eva’s place. He couldn’t wait to get to work—an odd sensation for him. When at Peece Canning, Adam resented each day buried in boring paperwork and dull meetings, no matter how good his head for business might be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hands-on work. That was what he’d always preferred. He liked control of his own results. He’d tried several positions at Peece Canning but had failed to stay interested. Inspired. The feeling that he was about to strike gold had everything to do with learning how to prune his cherry trees. It had nothing to do with a pair of milk chocolate–colored eyes framed by thick, dark lashes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned off the main road and pulled into the driveway, parking near a big red truck with a plow. Eva’s? If so, it was a mighty big vehicle for such a diminutive woman. He climbed out of his Jeep and breathed deeply. The February air seared his lungs, but he didn’t care about the cold. He felt alive for the first time in a very long while.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Recommitting his heart to God at Christmas had been part of a series of changes he’d made in his life. Pushing ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("thirty, it was about time he discovered his purpose. What God meant for him to do and who to be.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("God, please be with me and help me get it right. I don’t want this to be one more screwup.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam stared out over the eighty acres that now belonged to him with a sense of awe. The morning sun shrouded by thin clouds cast a pink glow against the bare orchard sloping in front of him. The gray waters of Lake Leelanau shone in the distance like a flat stone dusted with snow and ice. Beyond the far hills, Lake Michigan bled into a gray sky with the sandy face of South Fox Island breaking the color of the horizon. The view was spectacular and humbled his spirit. Could he make this work?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Morning, Peece. You going to be warm enough?” Eva Marsh dressed head to toe in deer-colored canvas, stepped off the porch with a big basket over her arm. Was she planning an ice picnic?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He walked toward her. He’d skied in frozen temperatures all over the world. He didn’t have to dress like a northern Michigan yokel to stay warm. “I dressed for outside work, if that’s what you mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The guy that followed Eva could have been her twin, except that he stood about a foot taller than her. Also dressed in heavy canvas coveralls, he towered over both of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is my brother Ryan. He’s helping out today. A couple of interns at the research center can join us later in the week if you decide not to stay,” Eva said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d given Eva an expense budget, but he wasn’t ready to use it. It looked as if he’d have to prove to his pretty employee that he had every intention of staying on permanently. God willing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even so, Adam extended his hand to Ryan. “Nice to meet you.”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This your first time pruning, Adam?” Ryan didn’t look much older than Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.” And he was going to enjoy every minute of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ryan glanced at Eva and she gave him an I-told-you-so look. Either Eva had picked up on his excitement or she’d conveyed her city-boy-can’t-do-real-work prejudice to her brother. Probably the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ve got fifteen acres of dormant sweet cherry trees to do. Another five acres of young sweets need pruning come spring. My dad had the tart orchard pruned last year so that’ll be good for another couple years yet,” Eva said over her shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam followed her as she strode toward a two-story barnlike garage with red clapboard siding that matched the house. With a push of a button, one of the two doors lifted with a squeak against the cold. Three ATVs were parked inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His pulse kicked up a few beats. “Nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You like to ride?” Ryan asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anything with speed and I’m there.” Adam kept pace with Ryan into the garage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ryan laughed, making clouds of white with his breath. “Me, too. My dad bought a third four-wheeler because Eva doesn’t play passenger very well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam glanced at Eva. He could see that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva started the engine of her ATV, drove it into the driveway and stopped. A small wagon loaded with gear had been hooked onto the back. She pulled up her fleece balaclava to cover her nose and revved the engine. “Follow me, Peece.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You seem to like my last name.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva’s pretty eyes widened over the rim of her fleece covering. “I can call you sir if you’d rather.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("He wondered why she wouldn’t use his first name. “No ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("way. Peece is fine, but it’s what my college roommates called me. If I regress, that’s on you.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A smile reached her eyes. “I’ll take my chances.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam enjoyed this spunky Eva who looked ready for anything. He started his engine and, with a grin, squealed the tires out of the garage. In no time, they were jostling down a pristine white path into the orchard. They passed a section of smaller trees, their bases wrapped with what looked like plastic tubes. At one point, Ryan veered off into a parallel row and sped forward, spraying a tail of snow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam grinned and followed suit. He couldn’t get lost with only one way to go, straight ahead. So he gunned it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked back to see Eva chugging behind them. Ryan tore down the next row over, so Adam bit the racing bait with a jerky jump forward as he revved the throttle. Playing chase, they sped along slipping between trees until Ryan darted in another direction. From out of nowhere, the path ended. The orchard stopped and a fence loomed ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam swerved left. Applying the brake too quick, he spun and tipped into a cherry tree. His shoulder hit first, then the four-wheeler pinned his leg against a surprisingly solid mass for a thin trunk. Great. He was stuck. After a few minutes of trying and failing to loosen his leg enough to leverage the ATV back onto all four wheels, he heard Eva’s approach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head at him as if he’d been caught stealing one of her scones without asking. “What are you, twelve?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So much for worrying about him. He wasn’t physically hurt, just his pride, but still, she could at least "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("look")]), _vm._v(" concerned. He laughed. “Sometimes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("He heard her chuckle under her breath, and then she climbed up onto the high side foot bed and grabbed the ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("handlebar. With considerable strength for her small stature and a deep grunt, she leaned back and righted his ATV.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rubbed his calf. “Ow, that was my leg…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re the one tearing around.” She gave him a smarty-pants grin and then, without tossing an ounce of pity his way, she knelt and gently ran her gloved hands down the trunk of the tree he’d hit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, what about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled down her balaclava. “You’ll live. The tree might not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He climbed off his four-wheeler and knelt next to her. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She scooted around to the other side of the tree, looking for damage there. “See this gash?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Instead of concentrating on her instruction, he watched her pretty face. The tip of her nose looked red. “Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Abruptly, she stood and stepped to the other side of the ATV. “Wound a tree and insects or rot can set in. Get a bad case of bugs because of a wound, and lose an entire section of crop.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah. Oh.” She’d reduced him to feeling like a twelve-year-old. One who’d just been clued in to the serious consequences of his actions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can’t you put some goop on it, or wax?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “Doesn’t work that way. Artificial remedies usually make it worse. I’ll have Ryan check it out. It’s a young tree. It might heal itself. We’ll have to keep an eye on it come spring.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam liked the sound of her using the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we.")]), _vm._v(" He wanted them to work as a team. Despite being her boss, he wanted to establish a comfortable working relationship that was friendly. But not too friendly. Considering how attractive he found Eva, that might present a challenge.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on, we’ll trim a few rows down.” Eva climbed back on her four-wheeler.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He followed at a sedate pace. In minutes they stopped and Eva grabbed a milk crate from the back of his ATV.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s that for?” Adam asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Reaching the middle branches. I’ve got extended loppers for the tops.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lugged a small stepladder from her wagon. “I need a little more height.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After getting set up, Eva motioned for him to come closer. “This is what we’re trying to do. Look at the tree and envision it covered with leaves. Prune back branches that will block sunlight to the center of the tree. Light makes more cherries.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He recognized the same fire in Eva’s eyes that had been in her father’s. The same passion for the work. Robert Marsh had been right. No one cared more for this orchard than his daughter. Last fall, Adam had fallen in love with this land just as they had, only he needed to learn how to make it grow and produce a living.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gestured for him to come near. “Watch how I make the cuts. We’ll work down this row, then come back on the next one over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva stood on the top step, so Adam took the bottom. Through the smell of ATV exhaust on her jacket, he caught a delicate scent. Maybe it was her perfume, or the shampoo she’d used. Whatever it was, he wouldn’t mind getting a closer sniff. He peered around her shoulder, breathing deep. “Looks easy enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Once you get the hang of it.” She turned to look at him but leaned too far back and slipped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Whoa.” Adam grabbed her upper arms to keep her from toppling.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She overcompensated and slipped down onto the bottom step, landing on his foot. Her eyes went wide and Adam caught a flicker of panic race across her face. “You can let go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped back and raised his hands in surrender. “I didn’t want you to fall. Worker’s comp is not good on the first day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam smiled but he was curious to know what pulling her close would feel like. He suspected that she’d fit pretty well in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva inhaled big gulps of frosty air while her pulse hammered in her ears. She needed to put space between her and Adam fast. Those bright blue eyes of his were a drowning place where she worried she couldn’t stay afloat. “Thanks. Think you can handle your own set of loppers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He chuckled. “Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good.” But could she handle working beside Adam? She wasn’t sure. It didn’t really matter. She had a job to do, so she’d better toughen up real quick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They pruned tree after tree with little conversation other than Eva checking his cuts and admitting he did them well. She’d catch Adam humming and then he’d smile at her, making her insides pitch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wished she didn’t find Adam Peece so attractive. She might as well ask the sky to stop snowing for all the good it would do. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Why, God? Why’d it have to be someone so handsome like him?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although Eva attended church every week, she wasn’t exactly on good speaking terms with the Lord. She stopped expecting His help a couple years ago after blaming God for what her boyfriend Todd had done. There was no easy way of getting over that kind of betrayal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Eva made another vicious chop, but cutting off her ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("memories wasn’t as easy as trimming a cherry tree. Mistrust lurked deep in her still, ruining any hopes she’d had of dating. It was easier to keep guys at a safe distance. She stayed in control that way.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva blew out a breath of pent-up air. But then Adam Peece barged into her controlled world and lingered in her thoughts far too often. Working long hours beside him was bound to be more difficult than she anticipated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What if she grew to care for him? Not likely, but working together for months in the field, who knew? Still, Eva wasn’t cut out for a guy like Adam Peece. And someone like him wouldn’t give her a serious look. Not in a thousand Sundays.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shortly after noon, Ryan pulled up on his four-wheeler. “I’m hungry, Eva, what’d you bring to eat?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stuff.” She trudged toward her ATV, stepladder in hand. Her brother had eaten a huge breakfast before they came out, but it was tough keeping that six-foot-two frame of his filled. “Come on. I guess a break’s in order. Bring your crate to sit on, Peece.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam had caught on to pruning quickly, making clean cuts and moving on. She’d checked his work repeatedly and was more than satisfied with what she saw. She didn’t want him to enjoy this. She wished he’d go back to his canning kingdom in Detroit and let her do the work in peace. She’d make a good farm manager, but hands-on teacher? Right.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She opened her basket and drew out three thermoses. “Here’s tomato soup.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on, Eva, that won’t fill me up,” Ryan whined, perched on his four-wheeler.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And chicken salad sandwiches.” She offered one to Adam before handing the plate to her brother. “There’s hot chocolate, too. Well, it’s probably lukewarm by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cherries?” Adam looked up from his sandwich.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She puts them in everything,” Ryan said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva made a face. “If you’re going to complain, you can make your own lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m just stating a fact.” Her brother laughed at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva knew she’d overreacted. Just because Adam got under her skin was no excuse to take it out on Ryan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long will pruning take?” Adam blew into his gloves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“On these trees? A few weeks.” Eva smiled. If he skipped the rest of it, Eva might get more work done with Ryan’s help and his two interns. Most of them knew how to trim a fruit tree as part of their agricultural education.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That long?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sometimes longer. Depends on the amount of help.” Eva took a drink of warm soup.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your dad said he had two sons. Where’s your other brother?” Adam sipped from his thermos.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva glanced at Ryan. “He’s out on the mission field.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her brother snorted. “Wasting time, if you ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ryan!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam looked confused. “He’s a missionary?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva nodded. “Sin’s an ordained minister, but he’s more into education. He’s training native missionaries in Haiti.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam tipped his head. “Your brother’s name is Sin?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Short for Sinclair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ironic nickname for a minister.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ryan laughed. “Not if you knew him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“Just stop it.” Eva bit into her sandwich. It hurt that her brothers hardly spoke. They were both hardheaded ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("and sticking to what they thought were noble principles. Sinclair punished himself for his part in an accident that took the life of Ryan’s girlfriend. Ryan blamed himself, but he resented Sin’s absence. He’d had to face Sara’s folks alone.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After lunch, Eva grabbed the long pruning loppers to tackle another row of trees. Within hours, the snowflakes grew fatter and more insistent. They stuck to her eyelashes and blurred her vision. She brushed them away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced at Adam on his milk crate. He’d slowed down considerably from this morning and kept blowing into his gloves. “Are you cold?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just my hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She searched the wagon. Pulling out another pair of heavy-duty work gloves, she walked toward him. “Try these.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam tucked his expensive-looking ski gloves into his coat pockets. The tips of his fingers were white with a purple hue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva grabbed his hands. “Let me see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam tried to pull back. “They’re fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, they’re not.” Eva took off her gloves and touched his frozen skin. “We have to get you back to the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Give me those and I’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nope. You’ve got frostbite starting on your fingertips. Time to call it a day. I’ll let Ryan know.” Eva looked at Adam’s face. The tip of his nose had turned white, too. The most important thing was to get Adam back home where it was warm.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Adam sat in Eva’s cheerfully decorated kitchen once again. Antiques mixed with brightly colored modern-looking fabrics but it blended well. The place had life. Vibrance. This time his hands were plunged into bowls of ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("warm water while Eva built a fire in the woodstove. The snap and crackle of igniting wood cut the silence. And Adam felt like an idiot. Obviously he needed better gloves, and he’d have to pick up a fleece balaclava to protect his face if he planned to work an eight-hour day alongside the formidable Eva Marsh.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, I take it your family are churchgoers, to have a brother in ministry.” Adam couldn’t take the quiet. It was too much like when he was in grade school and sent to the principal’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I went to church when I was a kid.” His mother used to take him to Sunday school and church every week. A few years after she’d died, when he’d hit his teens, Adam took a detour away from everything he’d been taught about honoring God. He stayed on that road too long, making choices he wasn’t proud of now that he’d given his heart back to the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva shut the woodstove doors. “Do you attend now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I can.” He wanted to settle in somewhere and go regularly. He needed a home church to call his own. A place to grow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After attending a Christian concert with his sister over the holidays, Adam hadn’t anticipated God grabbing hold of him, but he was grateful for the second chance. Another puzzle piece of his life found its place. Adam might not have all the pieces locked in yet, but he was on his way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked her square in the eye and wanted her to know he’d changed. “I recently came back to my faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes widened with surprise. “Looks like you’ll have to change your lifestyle.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("She couldn’t know what his life had been before—the parties filled with women and friends looking for what they could glean from him. Not that he cared to enlighten ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("her. He was over it. Finished. Still, he smiled at her sharp tongue, and then laughed when the shock on her face registered as if she’d accidentally spoken her thoughts out loud.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam knew he had a lot to live down. “I thought Christians were supposed be nice. Love thy neighbor and pray for your enemies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes glazed with remorse, and then she laughed, but her amusement sounded forced. “Yeah, well, I’m working on that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So, have you decided if I’m your neighbor or your enemy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced at the clock on the wall, obviously uncomfortable with his probing. “I don’t know yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the brief flash of pain in her chocolatey eyes bothered him. It wasn’t easy accepting his part in her disappointment. He knew buying her family’s orchard had been a blow to her dreams of one day taking over the farm. Her father had pretty much spelled that out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Adam suspected the resentment went deeper than the sale of the land. She seemed lost and alone. Almost afraid, like a small force in a big world gone awry. Which was crazy considering that Eva Marsh proved quite capable of taking care of herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me see your hands.” Eva peeked into the bowl, effectively shutting down his thoughts by her nearness. Something about her definitely piqued his interest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He lifted his hands and winced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced at him with real concern and then gently touched the skin of his fingers. “As they thaw, it’s going to hurt.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("“You’re not kidding.” Adam had experienced cold but never like this. He peered into Eva’s eyes, and for a few ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("moments she didn’t look away. She didn’t let go of his hands either.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then the door opened, and Eva’s roommate blew in with a rush of bitter air. Beth took one look at him and rushed forward. “Adam, what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Frostbite.” Eva moved away, leaving Adam to wish her roommate back at school.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth’s expression turned to mush. “Oh, you poor thing. Can I get you anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This")]), _vm._v(" was what Adam was used to, but oddly enough he didn’t want Beth hovering over him. “I’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled. “You gotta watch Eva, she’s a tough taskmaster.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam noticed the flush of color on Eva’s cheeks and grinned. “She’s not so bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wait till you get to know her better.” Beth winked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had Eva heard Beth’s comment? By the way his prickly little employee bustled about the kitchen, he was pretty sure she had. Maybe she wasn’t immune to him after all.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the first week’s worth of pruning beside Adam, Eva needed to unwind. Saturday night, she succeeded for a couple of hours at the movies with Ryan and Beth. She hadn’t thought of Adam Peece once during the big-budget sci-fi flick. Except for the moment she decided that the lead actor’s brilliant blue eyes were no comparison to Adam’s.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("After his bout with frostbite, Adam had shown up for work wearing better gear and he went the distance in the field. She thought for sure he’d bail after a few days spent working outside in the bitter cold. Instead, he arrived every morning eager to work. Ryan had shown him how to use ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("a small chainsaw on the bigger branches needing to be clipped from older trees.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The instant camaraderie between the two men pricked like a thorn in her finger. She’d always considered her brother a good judge of character. Either his discernment was off or her apprehension of Adam was overblown. Neither sat well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wanna grab a bite to eat?” Ryan pulled his truck into the latest hot spot in Traverse City.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why here?” Eva didn’t care to hang out in a loud place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They have the best wings in town. Come on, Beth, back me up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth laughed. “You’re looking to scope the ladies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right.” Ryan’s mouth twisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva had given up badgering Ryan to ask Beth out since her brother showed no signs of interest. For anyone. His hurt still ran too deep. But then, so did hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After they found a table, Eva looked around the crowded restaurant. The bar was full, and the surrounding tables were jammed. She spotted movement in the corner and heard shrill feminine laughter. And then she saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam sat at the end of a table made for eight with at least twelve people squeezed around it. Adam sat between two women, his arms draped loosely around each one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, Adam.” Ryan waved.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Under the table, Eva pinched her brother’s thigh. “Don’t call him over here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why not?” Ryan feigned innocence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth turned and waved, too.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("It was hard enough working with him—Eva didn’t want to socialize, too. But like a fly drawn to rotting fruit, Eva glanced at Adam. His blue eyes stared straight through her ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("as he disengaged from the pouty-lipped women and made his way toward them.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great,” Eva growled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How come your cheeks are red, Eva?” Ryan winked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to hide, which made her cheeks feel that much hotter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth played traitor and pulled out a chair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam slipped into the seat. “Had some great skiing today. What are you guys up to?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We went to the movies,” Beth answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva peeked at the table Adam had left behind. Some of the women took pictures with their cell phones. Maybe that was why he’d been cuddled between two beauties—he was getting his picture taken. Not that it was any of her business what he did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you guys interested in coming to my place to ski tomorrow? I’ll spring for your lift tickets.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, thanks,” Eva answered with more volume than her brother. “We’ve got church in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ryan looked at her as if she’d spit ice cubes across the table and then turned to Adam. “Why don’t you come with us to church? We can ski afterward.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva jumped in before Adam could answer. “He’s not going to want to drive all the way from Benzie County for church.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let the man answer for himself,” Ryan said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva glanced at Adam. He fiddled with the salt and pepper shakers, but his gaze rested firmly on her. The taunt she’d flung at him about changing his lifestyle rang through her brain. Surely he wouldn’t attend church to spite her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hmm. I’m staying at a friend’s place not too far from you guys, so I could make church.”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva cringed. Ryan had a big mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d love to ski, but I have dinner plans with my mom right after service. Why don’t you pick us up at nine thirty?” Beth’s smile was a little too wide.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam tapped the table with his fingertips. Not a trace of damage from his scrape with frostbite. “Is that okay with you, Eva?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What could she say? Refusing now would only make her look like being around Adam got to her. Backed into a corner, she decided nonchalance was the best shield of defense. “Sure, that’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He studied her longer than she thought necessary before answering. “Then I’ll see you tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva watched him return to his table of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("friends")]), _vm._v(". The volume of laughter rose, and one of the women he’d had his arm around threw her a curious glance and then settled on Beth. Creases of doubt wrinkled the woman’s forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ryan rubbed his chin. “I’m definitely taking him up on his offer to ski tomorrow. You going, Eva?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!” Maybe she’d been abrupt in her answer, but the company Adam Peece kept supported what she thought. He was a shallow guy trying out a new hobby. Those women at his table no doubt thought a gentleman cherry grower was a charming side job. Eva might work for the man, but she wasn’t about to hang out with him, too. No way, no how.")])])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page35"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7510c942","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426885297_ch02.vue
// module id = 84
// module chunks = 0